// Copyright (c) 2021, Comsearch, Inc., All rights reserved

import { castToFloat } from 'helpers/reduxFormFunctions'

/**
 @typedef cleanedBackToBack
 @type {object}
 @property {Number} commonLoss
 @property {String} polarizationChange - 'yes' || 'no'
 */

/**
 * takes backToBack array from path details (redux-form)
 * and returns an object with commonLoss and polarizationChange for the Passive Repeater
 * @param {Array} backToBack - array of specific Back-to-Back Passive Repeater data
 * @returns {cleanedBackToBack}
 */
const getBackToBackData = backToBack => (
  backToBack.reduce((a, d) => {
    a.commonLoss = castToFloat(d.commonLoss)
    a.polarizationChange = d.polarizationChange === 'yes'
    return a
  }, {})
)

export default getBackToBackData
